(function(){
  var cfg = window.HW || {};
  var CODE = cfg.code || 'SPOOKY';
  var TZ = 'America/Chicago';
  var CART_LOGO = 'https://cdn.shopify.com/s/files/1/1062/3103/8277/files/belorin_halloween_logo.png?v=1792381281&width=500';

  /* Countdown to midnight US Central, resets every day */
  function secondsLeft(){
    var p = {};
    new Intl.DateTimeFormat('en-US',{timeZone:TZ,hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'})
      .formatToParts(new Date()).forEach(function(x){ if(x.type !== 'literal') p[x.type] = parseInt(x.value,10); });
    var s = 86400 - (p.hour*3600 + p.minute*60 + p.second);
    return s <= 0 ? 86400 : s;
  }
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function tick(){
    var s = secondsLeft(), h = Math.floor(s/3600), m = Math.floor((s%3600)/60), sec = s%60;
    var timers = document.querySelectorAll('[data-hw-timer]');
    for (var i=0;i<timers.length;i++){
      var t = timers[i];
      var a = t.querySelector('[data-h]'), b = t.querySelector('[data-m]'), c = t.querySelector('[data-s]');
      if (a && a.textContent !== pad(h)) a.textContent = pad(h);
      if (b && b.textContent !== pad(m)) b.textContent = pad(m);
      if (c) c.textContent = pad(sec);
    }
  }
  tick();
  setInterval(tick, 1000);

  /* Click-to-copy discount code */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-hw-code]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var code = btn.getAttribute('data-hw-code');
    var done = function(){ btn.classList.add('is-copied'); setTimeout(function(){ btn.classList.remove('is-copied'); }, 2000); };
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, done); } else { done(); }
  }, true);

  /* Product promo: discount % follows the selected variant */
  function setOff(variantId){
    var promo = document.querySelector('[data-hw-promo]');
    if (!promo) return;
    try {
      var ids = JSON.parse(promo.querySelector('[data-hw-variants]').textContent);
      var offs = JSON.parse(promo.querySelector('[data-hw-offs]').textContent);
      var i = ids.indexOf(Number(variantId));
      if (i < 0) return;
      var off = offs[i] || 0;
      promo.querySelector('[data-hw-off]').textContent = off;
      promo.querySelector('[data-hw-off-wrap]').hidden = off <= 0;
    } catch(err) {}
  }
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    window.subscribe(PUB_SUB_EVENTS.variantChange, function(e){ if (e && e.data && e.data.variant) setOff(e.data.variant.id); });
  }
  document.addEventListener('change', function(e){
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (idInput) setTimeout(function(){ setOff(idInput.value); }, 50);
  });
  var lastId = null;
  setInterval(function(){
    var idInput = document.querySelector('product-form form [name="id"], form[action*="/cart/add"] [name="id"]');
    if (idInput && idInput.value !== lastId) { lastId = idInput.value; setOff(lastId); }
  }, 700);

  /* Halloween logo in the Kaching cart header */
  function cartLogo(header){
    if (header.querySelector('.hw-cart-logo')) return;
    var img = header.querySelector('img');
    if (img) {
      img.src = CART_LOGO;
      img.removeAttribute('srcset');
      img.classList.add('hw-cart-logo');
      img.alt = 'Belorin';
      return;
    }
    var leaves = header.querySelectorAll('h1,h2,h3,h4,p,span,div');
    for (var k=0;k<leaves.length;k++){
      var el = leaves[k];
      if (el.children.length === 0 && !el.closest('button') && /belorin/i.test(el.textContent)) {
        el.innerHTML = '<span class="hw-cart-logo-wrap"><img class="hw-cart-logo" src="' + CART_LOGO + '" alt="Belorin"></span>';
        return;
      }
    }
  }

  /* Discount reminder in cart drawers + Halloween text for app widgets (survives re-renders) */
  var BUNDLE_TITLE = 'Halloween Sale Ends Today';
  function note(){
    var d = document.createElement('div');
    d.className = 'hw-cartnote';
    d.setAttribute('data-hw-cartnote','');
    d.innerHTML = '🎃 <strong>Extra 10% off</strong> with code <button type="button" class="hw-code" data-hw-code="' + CODE + '">' + CODE + '</button> at checkout';
    return d;
  }
  var targets = ['.kaching-cart__footer', '#CartDrawer .drawer__footer', '#main-cart-footer .cart__blocks'];
  function inject(){
    for (var i=0;i<targets.length;i++){
      var el = document.querySelector(targets[i]);
      if (el && !el.querySelector('[data-hw-cartnote]')) el.insertBefore(note(), el.firstChild);
    }
    var titles = document.querySelectorAll('.kaching-bundles__block-title');
    for (var j=0;j<titles.length;j++){
      if (titles[j].textContent !== BUNDLE_TITLE) titles[j].textContent = BUNDLE_TITLE;
    }
    var header = document.querySelector('.kaching-cart__inner .kaching-cart__header');
    if (header) {
      cartLogo(header);
      if (header.parentNode && !header.parentNode.querySelector('.hw-cart-hello')) {
        var hello = document.createElement('div');
        hello.className = 'hw-cart-hello';
        hello.innerHTML = 'Halloween Sale Ends <span>Today</span>';
        header.parentNode.insertBefore(hello, header.nextSibling);
      }
    }
  }
  var queued = false;
  function schedule(){ if (queued) return; queued = true; requestAnimationFrame(function(){ queued = false; inject(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject); else inject();
  new MutationObserver(schedule).observe(document.documentElement, {childList:true, subtree:true});

  /* Flying bats (optional) */
  if (cfg.bats && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var wrap = document.createElement('div');
    wrap.className = 'hw-bats';
    wrap.setAttribute('aria-hidden','true');
    var BAT = '<svg viewBox="0 0 100 50"><path d="M50 14c2-4 3-8 3-11 2 3 2 6 1 9 5-1 8-4 10-9 4 9 14 13 32 13-9 3-14 9-15 17-5-5-11-7-17-4-2-5-7-7-14-7s-12 2-14 7c-6-3-12-1-17 4-1-8-6-14-15-17 18 0 28-4 32-13 2 5 5 8 10 9-1-3-1-6 1-9 0 3 1 7 3 11z"/></svg>';
    var spawn = function(){
      var w = window.innerWidth, left = Math.random() < .5, dur = 7 + Math.random()*6;
      var b = document.createElement('div');
      b.className = 'hw-bat';
      b.style.width = (24 + Math.random()*26) + 'px';
      b.style.top = (6 + Math.random()*55) + 'vh';
      b.style.left = left ? '-70px' : (w + 20) + 'px';
      b.style.setProperty('--dx', (left ? 1 : -1) * (w + 140) + 'px');
      b.style.setProperty('--dy', (Math.random()*30 - 15) + 'vh');
      b.style.animationDuration = dur + 's';
      b.innerHTML = BAT;
      wrap.appendChild(b);
      setTimeout(function(){ b.remove(); }, dur*1000 + 300);
    };
    var start = function(){
      document.body.appendChild(wrap);
      setTimeout(spawn, 1200);
      setTimeout(spawn, 2600);
      setInterval(function(){ if (!document.hidden && wrap.children.length < 3) spawn(); }, 4500);
    };
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  }
})();
